export default "/images/5ad7240783d0e9b4fc7aa7ac24fb701c.avif";